import PropTypes from 'prop-types'

const Icon = ({ size, svg, ...attrs }) => {
  const defaultSize = '1em'
  if (!size) {
    size = defaultSize
  } else if (typeof size === 'number') {
    size = `${size}px`
  }
  const { style = {} } = attrs
  attrs.style = { ...style, height: size, width: size }
  const TagName = svg

  return <TagName {...attrs} height={size} width={size} />
}

Icon.propTypes = {
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  svg: PropTypes.oneOfType([PropTypes.node, PropTypes.element, PropTypes.func])
}

export default Icon
